var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"press-releases-release-card"},[_c('div',{staticClass:"publish-date"},[_vm._v("\n        "+_vm._s(_vm.publishDate)+"\n    ")]),_vm._v(" "),_c('dynamic-link',{staticClass:"release-link",attrs:{"to":_vm.getUrl(_vm.slug)}},[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }